export default [
    {
        key: "Envelop",
        weight: [
            {
                size: "Envelop" ,
                max_weight:  1000
            }
        ]
    },
    {
        key: "PM",
        weight: [
            {
                size: "PM" ,
                max_weight:  1000
            }
        ]
    },
    {
        key: "PL",
        weight: [
            {
                size: "PL" ,
                max_weight:  1000
            }
        ]
    },
    {
        key: "40",
        weight: [
            {
                size: "40" ,
                max_weight:  5000
            },
            {
                size: "60" ,
                max_weight:  10000
            },
            {
                size: "90" ,
                max_weight:  15000
            },
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "50",
        weight: [
            {
                size: "50" ,
                max_weight:  5000
            },
            {
                size: "60" ,
                max_weight:  10000
            },
            {
                size: "90" ,
                max_weight:  15000
            },
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "60",
        weight: [
            {
                size: "60" ,
                max_weight:  10000
            },
            {
                size: "90" ,
                max_weight:  15000
            },
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "80",
        weight: [
            {
                size: "80" ,
                max_weight:  10000
            },
            {
                size: "90" ,
                max_weight:  15000
            },
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "90",
        weight: [
            {
                size: "90" ,
                max_weight:  15000
            },
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "100",
        weight: [
            {
                size: "100" ,
                max_weight:  15000
            },
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "120",
        weight: [
            {
                size: "120" ,
                max_weight:  15000
            },
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "140",
        weight: [
            {
                size: "140" ,
                max_weight:  20000
            },
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "160",
        weight: [
            {
                size: "160" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "180",
        weight: [
            {
                size: "180" ,
                max_weight:  25000
            }
        ]
    },
    {
        key: "200",
        weight: [
            {
                size: "200" ,
                max_weight:  25000
            }
        ]
    }, 
    {
        key: "250",
        weight: [
            {
                size: "250" ,
                max_weight:  25000
            }
        ]
    },
    
]